import { getPermissionMenuList } from '@/services/system/role'
import {
  getCircle,
  getCurrentChannelList,
  getHistoryChannel,
  getChannelByName
} from '@/services/system/channel'
import { getAccountListByRole } from '@/services/system/account'
import { getProjectFundOption } from '@/services/system/config'
import { Classification, translateDataToTree } from '@/utils/utils'
import type { Effect, Reducer } from 'umi'
import type { DictionaryModelState } from './connect'
import { apiGetVoteSchemeNameList } from '@/services/project/vote_scheme_config'
import { VoteSchemeConfigType } from '@/constants/project'
export interface DictionaryModelType {
  namespace: 'dictionary'
  state: DictionaryModelState
  effects: {
    initDictionary: Effect
    updateChannelInfo: Effect
    updatePermission: Effect
    updateFundData: Effect
  }
  reducers: {
    saveMenuList: Reducer<DictionaryModelState>
    saveCircle: Reducer<DictionaryModelState>
    saveChannelList: Reducer<DictionaryModelState>
    saveHistoryChannel: Reducer<DictionaryModelState>
    saveChannelNameList: Reducer<DictionaryModelState>
    saveFundList: Reducer<DictionaryModelState>
    saveSponsor: Reducer<DictionaryModelState>
  }
}

const DictionaryModel: DictionaryModelType = {
  namespace: 'dictionary',
  state: {
    allPermissionList: [],
    permissionTree: [],
    circleList: [],
    circleEnum: {},
    channelNameList: {},
    currentChannelList: [],
    allGroupChannel: {},
    allChannelList: [],
    channelEffectSubList: [],
    currentEffectChannelList: [],
    fundList: [],
    fundMap: {},
    entityMap: {},
    eventMarkList: [
      { key: 1, value: '其它' },
      { key: 2, value: 'Market' },
      { key: 3, value: 'BI' },
      { key: 4, value: 'Referral' }
    ],
    processStepList: [
      { key: 1, value: 'New', color: '546DFD' },
      { key: 2, value: 'To-do', color: '546DFD' },
      { key: 3, value: 'Watch', color: '546DFD' },
      { key: 4, value: 'Propose', color: '546DFD' },
      { key: '-1', value: 'Pass', color: 'A8DE4D' },
      // { key: 5, value: '发起Memo', color: 'F7981B' },
      { key: 6, value: 'Memo', color: 'F7981B' },
      { key: 7, value: 'PC通过', color: 'FFBC44' },
      { key: 8, value: 'TS', color: 'FFBC44' },
      { key: 9, value: 'Pipeline', color: 'FFBC44' },
      { key: 10, value: '已交割', color: 'FFBC44' }
    ],
    processStepEnum: {
      0: { value: 'Memo', color: '#F7981B' },
      1: { value: 'New', color: '#0C997D' },
      2: { value: 'To-do', color: '#0C997D' },
      3: { value: 'Watch', color: '#0C997D' },
      4: { value: 'Propose', color: '#0C997D' },
      '-1': { value: 'Pass', color: '#A8DE4D' },
      5: { value: '发起Memo', color: '#A8DE4D' },
      6: { value: 'Memo', color: '#F7981B' },
      7: { value: 'PC通过', color: '#FFBC44' },
      8: { value: 'TS', color: '#FFBC44' },
      9: { value: 'Pipeline', color: '#FFBC44' },
      10: { value: '已交割', color: '#FFBC44' },
      11: { value: 'FO不参与', color: '#0C997D' },
      12: { value: 'TC', color: '#F7981B' },
      13: { value: 'TC通过', color: '#FFBC44' },
      14: { value: 'TC金子弹通过', color: '#FFBC44' },
      15: { value: 'TC未通过', color: '#0C997D' },
      16: { value: '已交割', color: '#0C997D' }, /// 完成退出
      98: { value: '', color: '#0C997D' }
    },
    processStepLevelEnum: {
      1: { value: 'Pass' },
      2: { value: 'Team Pass' },
      3: { value: '未投票' },
      4: { value: 'PC未通过' },
      5: { value: 'Deal Drop' },
      6: { value: 'TS Drop' },
      7: { value: 'DD Drop' },
      8: { value: 'Deal Drop' },
      9: { value: 'ETS Drop' },
      10: { value: 'Final Drop' },
      11: { value: 'Other Drop' },
      12: { value: '后台暂停' },
      31: { value: '部分交割' }
    },

    // 新增项目模版“FO不参与” val = 7，但是不展示在下拉菜单中
    projectTypeList: [
      { key: 2, value: 'Red Template' },
      { key: 3, value: 'Growth Template' },
      { key: 1, value: '3Sigma Template' },
      { key: 5, value: 'Blue Template' },
      { key: 4, value: 'FollowOn Template' },
      { key: 9, value: 'Other Template' },
      { key: 6, value: 'Golden Template' }
    ],
    projectTypeEnum: {
      1: { value: '3Sigma Template' },
      2: { value: 'Red Template' },
      3: { value: 'Growth Template' },
      4: { value: 'FollowOn Template' },
      5: { value: 'Blue Template' },
      6: { value: 'Golden Template' },
      7: { value: 'FollowOn不参与' },
      9: { value: 'Other Template' },
      10: { value: 'TC Template' },
      11: { value: '退出/回款 Template' }
    },
    founderList: [
      // V1.9.1 Memo创始人年龄必填
      { key: 1, value: '20岁以下' },
      { key: 2, value: '20-24' },
      { key: 3, value: '25-29' },
      { key: 4, value: '30-34' },
      { key: 5, value: '35-39' },
      { key: 6, value: '40-44' },
      { key: 7, value: '45-49' },
      { key: 8, value: '50岁以上' },
      { key: 9, value: '不知道' }
    ],
    founderEnum: {
      1: { value: '20岁以下' },
      2: { value: '20-24' },
      3: { value: '25-29' },
      4: { value: '30-34' },
      5: { value: '35-39' },
      6: { value: '40-44' },
      7: { value: '45-49' },
      8: { value: '50岁以上' },
      9: { value: '不知道' }
    },
    moneyUnitList: [
      { key: 1, value: '$M' },
      { key: 2, value: '￥M' }
    ],
    moneyUnitEnum: {
      1: { value: '$M' },
      2: { value: '￥M' }
    },
    moneyTypeList: [
      { key: 1, value: '投前' },
      { key: 2, value: '投后' }
    ],
    moneyTypeEnum: {
      1: { value: '投前' },
      2: { value: '投后' }
    },
    projectFromList: [
      { key: 1, value: 'Self Sourcing' },
      { key: 2, value: 'Sponsor Sourcing' },
      // V1.9.0 Memo Sourcing选项新增Sector leader sourcing，并且需要增加SourcingBy字段
      { key: 3, value: 'Sector leader sourcing' },
      { key: 4, value: 'Other Sourcing' },
      { key: 5, value: 'Multiple Sourcing' }
    ],
    projectFromEnum: {
      1: { value: 'Self Sourcing' },
      2: { value: 'Sponsor Sourcing' },
      // V1.9.0 Memo Sourcing选项新增Sector leader sourcing，并且需要增加SourcingBy字段
      3: { value: 'Sector leader sourcing' },
      4: { value: 'Other Sourcing' },
      5: { value: 'Multiple Sourcing' }
    },
    sponsorList: [
      { key: 26, value: 'RL' },
      { key: 5, value: 'KEN' }
    ],
    sponsorEnum: {
      26: { value: 'RL' },
      5: { value: 'KEN' }
    },
    yesNoList: [
      { key: 1, value: '是' },
      { key: 2, value: '否' }
    ],
    yesNowEnum: {
      1: { value: '是' },
      2: { value: '否' }
    },
    rateEnum: ['C', 'B', 'B+', 'A', 'A+'],
    meetingTypeList: [
      { key: 5, value: 'Memo会', disabled: false },
      { key: 13, value: 'DD会', disabled: false },
      { key: 14, value: '二级Memo会', disabled: false },
      { key: 15, value: 'TC会', disabled: false },
      { key: 7, value: '周会', disabled: true },
      { key: 1, value: '双周会', disabled: true },
      { key: 8, value: '双月会', disabled: true },
      { key: 9, value: '合伙人会议', disabled: true },
      { key: 3, value: '季会', disabled: true },
      { key: 10, value: '年会', disabled: true },
      { key: 12, value: '主题会', disabled: false },
      { key: 16, value: 'Meet With', disabled: false }
    ],
    meetingTypeEnum: {
      5: { value: 'Memo会' },
      6: { value: '黑格尔' },
      7: { value: '周会' },
      1: { value: '双周会' },
      8: { value: '双月会' },
      9: { value: '合伙人会议' },
      3: { value: '季会' },
      10: { value: '年会' },
      2: { value: '月会' },
      4: { value: 'Memo会' },
      12: { value: '主题会' },
      13: { value: 'DD会' },
      14: { value: '二级Memo会' },
      15: { value: 'TC会' },
      16: { value: 'Meet With' }
    },
    voteSystemList: [
      { key: 2, value: '大IC' },
      { key: 3, value: '小IC' },
      { key: 11, value: 'RMB IC' },
      { key: 12, value: 'RMB 大IC' },
      { key: 4, value: '3Sigma' },
      { key: 1, value: 'Minority Thinking' },
      { key: 6, value: 'Growth IC' },
      { key: 5, value: '金子弹' },
      { key: 9, value: 'Special Pool' }
      // { key: 10, value: '哨兵' }
    ],
    voteSystemEnum: {
      1: { value: 'Minority Thinking' },
      2: { value: '大IC' },
      3: { value: '小IC' },
      11: { value: 'RMB IC' },
      12: { value: 'RMB 大IC' },
      4: { value: '3Sigma' },
      5: { value: '金子弹' },
      6: { value: 'Growth IC' },
      8: { value: '-' },
      9: { value: 'Special Pool' },
      10: { value: '哨兵' },
      100: { value: '其他' }
    },
    voteSchemeList: [
      { key: 2, value: '大IC' },
      { key: 3, value: '小IC' },
      { key: 11, value: 'RMB IC' },
      { key: 12, value: 'RMB 大IC' },
      { key: 5, value: 'Growth IC' },
      { key: 6, value: '3Sigma' },
      { key: 4, value: 'Minority Thinking' },
      { key: 7, value: '金子弹' },
      { key: 9, value: 'Special Pool' },
      // { key: 10, value: '哨兵' },
      // 20220607 需要新建一个投票机制，这个IC名称为“其他”，成员有Frank、Cloris和Addison
      { key: 100, value: '其他' }
    ],
    /** 2024月12月20日不使用，转而使用后端字段vote_scheme_name */
    voteSchemeEnum: {
      2: { value: '大IC' },
      3: { value: '小IC' },
      4: { value: 'Minority Thinking' },
      5: { value: 'Growth IC' },
      6: { value: '3Sigma' },
      7: { value: '金子弹' },
      9: { value: 'Special Pool' },
      10: { value: '哨兵' },
      11: { value: 'RMB IC' },
      12: { value: 'RMB 大IC' },
      100: { value: '其他' }
    },
    memoPhaseList: [
      { key: 1, value: '早期' },
      { key: 2, value: '成长期' },
      { key: 3, value: 'Follow On' }
    ],
    memoPhaseEnum: {
      1: { value: '早期' },
      2: { value: '成长期' },
      3: { value: 'Follow On' }
    },
    fundMoneyUnitList: [
      { key: 1, value: '美元' },
      { key: 2, value: '人民币' },
      { key: 3, value: '美元+人民币' }
    ],
    fundMoneyUnitEnum: {
      1: { value: '美元' },
      2: { value: '人民币' },
      3: { value: '美元+人民币' }
    },
    portfolioStatusList: [
      { key: 1, value: 'Active' },
      { key: 2, value: 'Dormant' },
      { key: 5, value: 'DT Write Off' },
      { key: 3, value: 'Exiting' },
      { key: 4, value: 'Full Exit' }
    ],
    portfolioStatusEnum: {
      1: { value: 'Active' },
      2: { value: 'Dormant' },
      3: { value: 'Exiting' },
      4: { value: 'Full Exit' },
      5: { value: 'DT Write Off' }
    },
    projectResolutionList: [
      { key: 2, value: '领投' },
      { key: 3, value: '联合领投' },
      { key: 1, value: '跟投' }
    ],
    projectResolutionEnum: {
      1: { value: '跟投' },
      2: { value: '领投' },
      3: { value: '联合领投' }
    },
    projectMemoDdEnum: {
      1: { value: 'FDD' },
      2: { value: 'LDD' },
      3: { value: 'CDD' },
      4: { value: 'Other DD' },
      5: { value: 'BDD' },
      6: { value: 'TDD' }
    },
    projectMemoColorEnum: {
      0: { value: '蓝色' },
      1: { value: '橙色' },
      2: { value: '绿色' },
      3: { value: '红色' },
      4: { value: '金色' }
    }
  },
  effects: {
    *updatePermission({ payload }, { call, put }) {
      const permissionRes = yield call(getPermissionMenuList, {})
      yield put({
        type: 'saveMenuList',
        payload: permissionRes?.data?.list || []
      })
    },

    *updateChannelInfo({ payload }, { call, put }) {
      // 赛道是其他的项目，编辑时会丢失赛道信息
      const circleRes = yield call(getCircle, {})
      yield put({
        type: 'saveCircle',
        payload: circleRes?.data?.list || []
      })

      const subChannelRes = yield call(getCurrentChannelList, {
        only_parent: false,
        is_all: true
      })
      yield put({
        type: 'saveChannelList',
        payload: {
          channel: subChannelRes.data.list || [],
          circleList: circleRes?.data?.list || []
        }
      })

      const historyChannel = yield call(getHistoryChannel, {
        only_parent: true,
        is_all: true
      })

      yield put({
        type: 'saveHistoryChannel',
        payload: historyChannel.data.list || []
      })

      const channelNameList = yield call(getChannelByName, {})

      yield put({
        type: 'saveChannelNameList',
        payload: channelNameList.data.list || []
      })
    },
    *updateFundData({ payload }, { call, put }) {
      const fundRes = yield call(getProjectFundOption, { need_fund_entity: 1 })
      yield put({
        type: 'saveFundList',
        payload: fundRes.data.list || []
      })
    },
    *initDictionary({ payload }, { call, put }) {
      const partnerRes = yield call(getAccountListByRole, {
        role_codes: ['partner'],
        is_hide_option: 1
      })
      yield put({
        type: 'saveSponsor',
        payload: partnerRes.data.list || []
      })
      yield put({
        type: 'updateChannelInfo'
      })
      yield put({
        type: 'updateFundData'
      })
      yield put({
        type: 'updatePermission'
      })
    }
  },
  reducers: {
    saveMenuList(state, { payload = [] }) {
      const treeData = translateDataToTree(JSON.parse(JSON.stringify(payload)) || [])
      return {
        ...state,
        allPermissionList: payload,
        permissionTree: treeData
      }
    },
    saveCircle(state, { payload = [] }) {
      const tempEnum = {}
      let tempList = payload.sort((a, b) => a.sort - b.sort)
      tempList = tempList.map((item: any) => {
        tempEnum[item.code] = { value: item.name }
        return {
          sort: item.sort,
          key: item.code,
          value: item.name
        }
      })

      return {
        ...state,
        circleEnum: tempEnum,
        circleList: tempList
      }
    },

    saveChannelList(state: any, { payload = {} }) {
      const channelList = JSON.parse(JSON.stringify(payload.channel))
      const filterDelChannel = channelList
        .filter(c => c.status === 1)
        .map(c => {
          c.list = c.list.filter(_c => _c.status === 1)
          return c
        })
      const filterEffectChannel = filterDelChannel
        .filter(c => c.channel_effective === 1)
        .map(c => {
          c.list = c.list.filter(_c => _c.channel_effective === 1)
          return c
        })
      const circleList = payload.circleList.sort((a, b) => a.sort - b.sort)
      return {
        ...state,
        allChannelList: payload.channel,
        channelEffectSubList: filterEffectChannel,
        currentEffectChannelList: Classification(filterEffectChannel, circleList),
        currentChannelList: Classification(filterDelChannel, circleList)
      }
    },
    saveHistoryChannel(state: any, { payload = [] }) {
      const allGroupChannel: any = {}
      payload.forEach((group: any) => {
        group.list.forEach(item => {
          allGroupChannel[item.id] = {
            ...item,
            status: group.status === 2 ? group.status : item.status
          }
        })
      })
      return {
        ...state,
        allGroupChannel: allGroupChannel
      }
    },
    saveChannelNameList(state: any, { payload = [] }) {
      const channelNameList: any = {}
      payload.forEach(c => {
        if (c.channel_id.length > 0) {
          channelNameList[c.channel_id[0]] = c
        }
      })
      return {
        ...state,
        channelNameList: channelNameList
      }
    },
    saveFundList(state, { payload = [] }) {
      const fundMap = {}
      const entityMap = {}
      payload.forEach(fund => {
        fundMap[fund.id] = fund
        fund.entities.forEach(entity => {
          entityMap[entity.id] = entity
        })
      })
      return {
        ...state,
        fundList: payload,
        fundMap,
        entityMap
      }
    },
    saveSponsor(state, { payload = [] }) {
      // Yu特殊处理的方案C
      // 2.在所有相关Sponsor选择中，隐藏Yu这个合伙人，所有涉及合伙人用户外露的地方，都要隐藏Yu
      payload = payload.filter(function (item: any, index: number) {
        // Yu的ID是27
        return item && item.id !== 27 && item.id !== 68
      })
      const tempEnum = {}
      const tempList = payload.map((item: any) => {
        tempEnum[item.id] = { value: item.name_en }

        return {
          key: item.id,
          value: item.name_en
        }
      })

      return {
        ...state,
        sponsorList: tempList,
        sponsorEnum: tempEnum
      }
    }
  }
}
export default DictionaryModel
